import classnames from 'classnames';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { memo } from 'react';

import styles from './index.less';

interface IProps extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  width?: string;
  height?: string;
  color?: string;
}

function SvgClose(props: IProps) {
  const { height, width, color, className, ...spanProps } = props;

  return (
    <span className={classnames(styles.svgContainer, className)} {...spanProps}>
      <svg
        fill={color || '#AFAEAE'}
        height={height || '24'}
        viewBox="0 0 1024 1024"
        width={width || '24'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M805.27,836.62a34.91,34.91,0,0,1-24.75-10.25L195.3,241.14a35,35,0,0,1,49.5-49.5L830,776.87a35,35,0,0,1-24.75,59.75Z" />
        <path d="M220.05,836.62a35,35,0,0,1-24.75-59.75L780.52,191.64a35,35,0,0,1,49.5,49.5L244.8,826.37A34.93,34.93,0,0,1,220.05,836.62Z" />
      </svg>
    </span>
  );
}

export default memo(SvgClose);
